"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeMultiSelectDropdownContentRow = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../../../../Icon");
require("./Row.scss");
const BadgeMultiSelectDropdownContentRow = (props) => {
    const { className = '', isSelected, title, onClick, onClose, } = props;
    const classNames = (0, classnames_1.default)('badge-multi-select-dropdown-content-row', className, { 'badge-multi-select-dropdown-content-row--selected': isSelected });
    return (react_1.default.createElement("div", { className: classNames, onClick: onClick },
        react_1.default.createElement("div", null, title),
        isSelected && (react_1.default.createElement("div", { onClick: onClose },
            react_1.default.createElement(Icon_1.Icon, { name: 'x' })))));
};
exports.BadgeMultiSelectDropdownContentRow = BadgeMultiSelectDropdownContentRow;
//# sourceMappingURL=Row.js.map